import type { JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import { Badge } from "./Badge";
import { Help } from "./icons";
import { IconValidationError, IconValidationWarning } from "./IconValidation";
import type { LabelProps } from "./Label";

interface Props extends LabelProps {
    length?: number;
    error?: string;
    warning?: string;
}

export function FormLabel({
    title,
    bold,
    className,
    length,
    error,
    warning,
    children,
    ...rest
}: Props): JSX.Element {
    return (
        <label
            {...rest}
            className={classNames("form-label", bold && "fw-bold", className)}
        >
            {children}
            {title != null && <Help className="ms-1" title={title} />}
            {length != null && <Badge className="ms-2">{length}</Badge>}
            {getObjectValidationIcon(error, warning)}
        </label>
    );
}

export function getObjectValidationIcon(
    error?: string,
    warning?: string,
): JSX.Element | null {
    if (error != null) {
        return <IconValidationError className="ms-2" title={error} />;
    }
    if (warning != null) {
        return <IconValidationWarning className="ms-2" title={warning} />;
    }
    return null;
}
